<template>
  <el-card class="h-full relative">
    <div class="w-full h-full">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="培训人姓名，课程"
          maxlength="50"
          v-model="searchData.name"
          clearable
        ></el-input>
        <el-date-picker
          v-model="searchData.date"
          type="daterange"
          class="mr-10px"
          size="small"
          range-separator="至"
          :start-placeholder="`${$t('开始日期')}`"
          :end-placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-select
          v-model="searchData.status"
          size="small"
          :placeholder="`${$t('培训状态')}`"
          class="mr-10px !w-50"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item"
            :value="index + 1"
          ></el-option>
        </el-select>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="培训人" prop="userName" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="所属单位"
          prop="orgUnitName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="课程名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="培训类型"
          prop="trainingTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="关联考试计划"
          prop="singleChoiceQuantity"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column label="课件包含学时" prop="coursewareTimes" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.coursewareTimes | showText('second') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="课件包含学分"
          prop="coursewareCredits"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column label="培训状态" prop="statusName" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column label="通过时间" prop="studyTimeEnd" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.studyTimeEnd | showText('time') }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewInfo(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <view-dia :visible.sync="showDialog" v-if="showDialog" :trainData="trainData" />
  </el-card>
</template>

<script>
import { TrainingRecordApi } from '@wiz-api/training-management'
import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'
import ViewDia from '../../components/trainManage/RecordInfo'
import { formatSeconds } from '../../components/EnumField'

const trainingRecordApi = new TrainingRecordApi()

export default {
  name: 'record-list',
  components: { ViewDia },
  filters: {
    showText: (val, type) => {
      let result = val
      if (type === 'time' && val) {
        result = dayjs(val).format('YYYY-MM-DD HH:mm:ss')
      }
      if (type === 'second' && val) {
        result = formatSeconds(val)
      }
      return result
    },
  },
  props: ['userId'],
  data() {
    return {
      statusList: ['进行中', '已培训', '超期未培训'],
      // 题目类型
      pageType: 'create',
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      searchData: {
        status: '',
        name: '',
        // studyTimeEnd: '',
        date: [],
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      showDialog: false,
      trainData: {},
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    // 查看详情
    viewInfo(data) {
      this.trainData = data
      this.showDialog = true
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...searchData,
        userId: this.userId,
      }
      if (this.searchData.date?.length) {
        data.dateStart = this.searchData.date[0]
        data.dateEnd = this.searchData.date[1]
      }
      this.equipTableLoading = true
      const [err, res] = await trainingRecordApi.getList(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
  mounted() {
    this.getEquipList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
